import { useCallback, useMemo } from "react";
import { useRouter } from "next/router";
import { getSelectedValue } from "@/utils/filterUtils";

export default function useFilterState(filterData) {
  const router = useRouter();

  const handleSelect = useCallback(
    (filterName, value) => {
      const currentQuery = { ...router.query };
      const queryKey = `attributes[${filterName.toLowerCase()}]`;

      // Handle existing values
      if (currentQuery[queryKey]) {
        const currentValues = currentQuery[queryKey].split(",");
        const valueIndex = currentValues.indexOf(value);

        if (valueIndex > -1) {
          // Remove value if already exists
          currentValues.splice(valueIndex, 1);
          if (currentValues.length === 0) {
            delete currentQuery[queryKey];
          } else {
            currentQuery[queryKey] = currentValues.join(",");
          }
        } else {
          // Append new value
          currentQuery[queryKey] = `${currentQuery[queryKey]},${value}`;
        }
      } else {
        // Set new value if doesn't exist
        currentQuery[queryKey] = value;
      }

      //const pageSlug = currentQuery.slug;
      //delete currentQuery.slug;

      router.push(
        {
          pathname: router.pathname,
          query: { ...currentQuery, page: 1 },
        },
        undefined,
        { shallow: true }
      );
    },
    [router]
  );

  const filterDataWithSelectedValues = useMemo(() => {
    return filterData?.map((filterOption) => ({
      ...filterOption,
      selectedValue: getSelectedValue(
        filterOption.slug,
        filterData,
        router.query
      ),
    }));
  }, [filterData, router.query]);

  return {
    handleSelect,
    filterDataWithSelectedValues,
  };
}
